/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Link as ThemeLink, LinkInterface } from '@lucid/gatsby-theme-lucid';
import { withTheme } from 'emotion-theming';
import { FC } from 'react';

import './link.scss';

export { LinkInterface };

const Link: FC<LinkInterface> = props => (
  <ThemeLink {...props} externalAlwaysNewTab />
);

export default withTheme(Link);
